import { KeyboardArrowDown } from '@mui/icons-material'
import { Box, Collapse, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { UICertificateIcon } from 'features/UI'
import { useState } from 'react'
import { Colors } from 'styles/colors'
import { CertificateItemType, CertificateListItem } from 'types'
import { useCertificates } from '../../hooks/useCertificates'
import { CertificateItem } from './CertificateItem'

export const Certificates = () => {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm'))
  const [isOpen, setIsOpen] = useState(false)

  const { certificates } = useCertificates()

  const certificateItems: CertificateListItem[] = [
    {
      itemType: CertificateItemType.CURRENT_RECORD,
      name: 'Individual Training Record',
    },
    ...certificates.map(
      (cert): CertificateListItem => ({
        itemType: CertificateItemType.REGULAR,
        certificate: cert,
      }),
    ),
  ]

  const toggleOpen = () => {
    setIsOpen(!isOpen)
  }

  return (
    <Stack
      sx={{
        background: 'white',
        padding: 1.5,
        borderRadius: 2,
        width: '100%',
        border: `1px solid ${Colors.PINK}`,
      }}
      style={{ marginTop: '8px', marginBottom: '8px' }}
    >
      <Stack
        direction="row"
        alignItems="center"
        onClick={toggleOpen}
        borderRadius={2}
        className="gap-8"
        sx={{ cursor: 'pointer' }}
      >
        <Stack
          direction="row"
          alignItems="center"
          flexGrow={1}
          flexWrap={matches ? 'wrap' : 'nowrap'}
          className="gap-8"
        >
          <Box display="flex" justifyContent="center" alignItems="center">
            <UICertificateIcon />
          </Box>
          <Typography
            fontWeight={400}
            variant="h5"
            flexGrow={1}
            sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}
          >
            Certificates
          </Typography>
        </Stack>

        <KeyboardArrowDown
          sx={{
            width: '2.25rem',
            height: '2.25rem',
            transform: isOpen ? 'rotate(-180deg)' : 'rotate(0)',
            transition: '0.2s',
          }}
        />
      </Stack>

      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <Stack
          textAlign="center"
          spacing={1}
          p={1}
          mt={2}
          borderRadius={2}
          sx={{ background: '#ccc' }}
        >
          {certificateItems.length > 1 ? (
            certificateItems.map((item) => (
              <CertificateItem
                key={
                  item.itemType === CertificateItemType.REGULAR
                    ? item.certificate.id
                    : item.itemType
                }
                item={item}
              />
            ))
          ) : (
            <Typography>No certificates yet</Typography>
          )}
        </Stack>
      </Collapse>
    </Stack>
  )
}
